import styled, { css } from 'styled-components';
import { SelectText, TextsContainer } from '../../Select/styled';
import type { ThemeStyles } from '../../../../styled/theme/types';

type ArrowProps = { theme: ThemeStyles; $hasValue?: boolean };

const getArrowFill = ({ theme, $hasValue }: ArrowProps) =>
  $hasValue ? theme.colors.text.primary : theme.colors.text.secondary;

export const numberSelectPopoverStyles = css`
  left: 0;
  right: 0;
  width: auto;
  padding: 0;
  overflow: visible;
  top: calc(100% + 15px);
`;

export const numberSelectTriggerStyles = css`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 8px 15px;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  ${TextsContainer} {
    width: 100%;
  }

  svg path {
    fill: ${getArrowFill};
    stroke: unset;
  }

  ${SelectText} {
    color: ${({ theme, $hasValue, $isError }) => {
      if ($isError) return theme.colors.systemColors.red;
      return theme.colors.text[$hasValue ? 'primary' : 'secondary'];
    }};
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const NumberListWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const NumberList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px 15px;
  max-height: 196px;
  overflow-y: scroll;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ScrollTrack = styled.div`
  position: absolute;
  right: 3px;
  top: 10px;
  bottom: 10px;
  width: 2px;
  background: ${({ theme }) => theme.colors.border.secondary};
  border-radius: 2px;
`;

export const ScrollThumb = styled.div<{ $top: number; $height: number }>`
  position: absolute;
  right: 0;
  width: 2px;
  top: ${({ $top }) => $top}px;
  height: ${({ $height }) => $height}px;
  background: ${({ theme }) => theme.colors.text.tertiary};
  border-radius: 2px;
`;

export const NumberItem = styled.li<{
  $isSelected: boolean;
  $isDisabled: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  height: 44px;
  padding: 0 15px;
  align-items: center;
  gap: 15px;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  font-size: 14px;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  font-weight: 400;
  color: ${({ theme, $isSelected, $isDisabled }) => {
    if ($isDisabled) return theme.colors.text.tertiary;
    if ($isSelected) return theme.colors.systemColors.blue;
    return theme.colors.text.primary;
  }};

  &:hover {
    border-radius: 14px;
    background-color: ${({ theme, $isDisabled }) =>
      $isDisabled ? 'transparent' : theme.colors.background.tertiary};
    color: ${({ theme, $isDisabled }) =>
      $isDisabled
        ? theme.colors.text.tertiary
        : theme.colors.systemColors.blue};
  }
`;
